import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectSelectedLanguage, setSelectedLanguage } from '../../app/features/builder/builderSlice';
import i18n from '../../i18n';

interface LanguageProviderProps {
  children: React.ReactNode;
}

const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const selectedLanguage = useAppSelector(selectSelectedLanguage);

  // On initial load, set i18n to use the language from the store
  useEffect(() => {
    if (selectedLanguage && i18n.language !== selectedLanguage) {
      i18n.changeLanguage(selectedLanguage);
    }
  }, [selectedLanguage]);

  // Listen for language changes from i18n and update the store
  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      if (lng !== selectedLanguage) {
        dispatch(setSelectedLanguage(lng));
      }
    };

    i18n.on('languageChanged', handleLanguageChanged);

    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [dispatch, selectedLanguage]);

  return <>{children}</>;
};

export default LanguageProvider; 